export class Notice {

    constructor() {
        this.id = null
        this.title = null
        this.content = null
        this.posting_started_at = null
        this.posting_finished_at = null
        this.posting_yn = null
        this.created_at = null
        this.updated_at = null
        this.deleted_at = null
    }
}






